export default [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    component: () =>
      import(/* webpackChunkName: "indexIndex" */ '../../pages/index/index.vue')
  },
  {
    path: '/index/echartsTest',
    component: () =>
      import(
        /* webpackChunkName: "indexEchartsTest" */ '../../pages/index/echartsTest.vue'
      )
  },
  {
    path: '/index/testcharts',
    component: () =>
      import(
        /* webpackChunkName: "indexTestcharts" */ '../../pages/index/testcharts.vue'
      )
  },
  {
    path: '/application',
    component: () =>
      import(
        /* webpackChunkName: "indexApplication" */ '../../pages/index/application.vue'
      )
  },
  {
    path: '/message',
    component: () =>
      import(
        /* webpackChunkName: 'indexMessage' */
        '../../pages/index/message.vue'
      ),
    meta: {
      title: '消息'
    }
  },
  {
    path: '/personal',
    component: () =>
      import(
        /* webpackChunkName: "indexPersonal" */ '../../pages/index/personal.vue'
      )
  },
  {
    path: '/mailLList',
    component: () =>
      import(
        /* webpackChunkName: "indexMailLList" */ '../../pages/index/mailLList.vue'
      ),
    meta: {
      title: '通讯录'
    }
  },
  {
    path: '/searchMail',
    component: () =>
      import(
        /* webpackChunkName: "indexSearchMail" */ '../../pages/index/searchMail.vue'
      ),
    meta: {
      title: '通讯录'
    }
  },
  {
    path: '/provincemaillist',
    component: () =>
      import(
        /* webpackChunkName: "indexProvincemaillist" */ '../../pages/index/provincemaillist.vue'
      )
  },
  {
    path: '/personList',
    component: () =>
      import(
        /* webpackChunkName: "indexPersonList" */ '../../pages/index/personList.vue'
      ),
    meta: {
      title: '最近联系人'
    }
  },
  {
    path: '/permissionsInfo',
    component: () =>
      import(
        /* webpackChunkName: "indexPermissionsInfo" */ '../../pages/index/permissionsInfo.vue'
      ),
    meta: {
      title: '权限信息'
    }
  },
  {
    path: '/infeedPage',
    component: () =>
      import(
        /* webpackChunkName: "indexInfeedPage" */ '../../components/infeedPage.vue'
      )
  },
  {
    path: '/agreement',
    component: () =>
      import(
        /* webpackChunkName: "indexagreement" */ '../../pages/index/agreement.vue'
      ),
    meta: {
      title: '服务协议'
    }
  },
  {
    path: '/secret',
    component: () =>
      import(
        /* webpackChunkName: "indexsecret" */ '../../pages/index/secret.vue'
      ),
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/privacyPolicySummary',
    component: () =>
      import(
        /* webpackChunkName: "indexprivacyPolicySummary" */ '../../pages/index/privacyPolicySummary.vue'
      ),
    meta: {
      title: '隐私政策摘要'
    }
  },
  {
    path: '/thirdSdk',
    component: () =>
      import(
        /* webpackChunkName: "indexsecret" */ '../../pages/index/thirdSdk.vue'
      ),
    meta: {
      title: '第三方SDK目录'
    }
  },
  {
    path: '/thirdShare',
    component: () =>
      import(
        /* webpackChunkName: "indexsecret" */ '../../pages/index/thirdShare.vue'
      ),
    meta: {
      title: '第三方共享信息目录'
    }
  },
  {
    path: '/reward',
    component: () =>
      import(
        /* webpackChunkName: "indexreward" */ '../../pages/feedback/index.vue'
      ),
    meta: {
      keepAlive: true,
      title: '意见反馈'
    }
  },
  {
    path: '/todoDetails',
    name: 'todoDetails',
    component: () =>
      import(
        /* webpackChunkName: "indexreward" */ '../../pages/index/todoDetails.vue'
      ),
    meta: {
      title: '待办详情'
    }
  },
  {
    path: '/agentDetails',
    name: 'agentDetails',
    component: () =>
      import(
        /* webpackChunkName: "indexreward" */ '../../pages/index/agentDetails.vue'
      ),
    meta: {
      title: '待办详情'
    }
  },
  {
    path: '/personalInformationCollection',
    name: 'PersonalInformationCollection',
    component: () =>
      import(
        /* webpackChunkName: "PersonalInformationCollection" */ '../../pages/index/privacyInfo.vue'
      ),
    meta: {
      title: '个人信息收集清单'
    }
  },
  {
    path: '/personalInformationCollection/detail',
    name: 'PersonalInformationCollectionDetail',
    component: () =>
      import(
        /* webpackChunkName: "PersonalInformationCollectionDetail" */ '../../pages/index/privacyCollectDetail.vue'
      ),
    meta: {
      title: '个人信息收集清单'
    }
  }
];
